// @flow
import React from 'react';
import type { TextBlock as TextBlockType } from 'message-parsing';

type TextBlockProps = {
  block: TextBlockType,
  inline?: boolean,
};
export default function TextBlock({ block, inline }: TextBlockProps) {
  const Tag = inline ? 'span' : 'div';
  return <Tag>{block.toString()}</Tag>;
}
TextBlock.defaultProps = {
  inline: false,
};
